import { useApi } from "../lib/api";
import { useSeo } from "../lib/seo";
import { PageHero } from "../components/shop/Common";
import { DestinationCard } from "../components/shop/DestinationCard";
import { DestinationSearch } from "../components/shop/DestinationSearch";

export default function DestinationsIndex() {
  const { data, loading } = useApi("/destinations", { featured: true });
  useSeo({ title: "Shop by Destination", description: "Shop vacation apparel by destination: Orlando, Miami, Las Vegas, New York City, Hawaii, Cancún, Puerto Rico, Jamaica, Bahamas, Curaçao and Aruba." });
  return (
    <>
      <PageHero eyebrow="Shop by destination" title="Where are you headed?" subtitle="Find apparel made for your trip.">
        <div className="mt-8 max-w-2xl relative z-20">
          <DestinationSearch variant="hero" />
        </div>
      </PageHero>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="destinations-grid">
          {loading
            ? Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-96 rounded-[28px] bg-sand animate-pulse" />)
            : data?.map((d) => <DestinationCard key={d.slug} d={d} className="h-96" />)}
        </div>
      </section>
    </>
  );
}
